import { ensureCommentActionSprite, getCommentActionIconSource } from "@/assets/icon/icons.js";
export default {
  name: "LocalSvgIcon",
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: ""
    },
    // 页面模块已有的本地 SVG 可以通过 src 复用此组件，无需先并入公共 sprite。
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    inheritColor: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      spriteReady: false
    };
  },
  computed: {
    iconSource() {
      // 显式传入本地 SVG 时直接由组件渲染；未传入时继续按名称读取公共 sprite。
      if (this.src) {
        return {
          type: "image",
          url: this.src
        };
      }

      // 普通图标返回 sprite href，大体积授权图标返回按需图片 URL。
      return getCommentActionIconSource(this.name, this.inheritColor);
    }
  },
  watch: {
    iconSource: {
      immediate: true,
      handler(source) {
        // sprite 图标只加载一次公共 sprite，注入 DOM 后再渲染 use，避免外链 currentColor 变黑。
        if (source.type !== "sprite") {
          this.spriteReady = true;
          return;
        }
        this.loadSprite();
      }
    }
  },
  methods: {
    async loadSprite() {
      this.spriteReady = false;
      try {
        await ensureCommentActionSprite();
        this.spriteReady = true;
      } catch (error) {
        // 精灵图短暂加载失败时保留空位，避免未处理的 Promise 异常影响页面其它交互。
        this.spriteReady = false;
      }
    }
  }
};